import { apiWrapper } from "@/services/api";

export const postQRCodeSupport = async (params) => {
  let response;
  try {
    response = await apiWrapper("POST", `qrcode-support`, params, false, null, "Migrated");
    return response.data;
  } catch (err) {
    console.log('ERROR"" postQRCodeSupport():', err);
    throw err;
  }
};
